//src/admin/pages/AdminReviews.js
import React, { useContext, useEffect, useMemo, useState } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getReviewRequestQueue,
  getReviewRequests,
  sendReviewRequests,
  deleteReviewRequest,
  getReviewConversation,
  sendAdminReviewReply,
  simulateCustomerReviewReply,
  simulateCustomerRatingReply,
  getProductReviews,
  updateProductReviewStatus,
  getReviewManualResolveOptions,
  resolveReviewManually,
  runReviewAutoRating,
resendReviewRequest,
} from "../../services/adminReviews.api";
import {
  FaSearch,
FaEye,
FaTrash,
FaCheck,
FaTimes,
  FaStar,
  FaWhatsapp,
  FaCheckSquare,
  FaRegSquare,
  FaImage,
  FaLanguage,
  FaPaperPlane,
} from "react-icons/fa";

function AdminReviews() {
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = useContext(AdminLanguageContext);
const showReviewTestingTools =
  process.env.NODE_ENV !== "production" ||
  process.env.REACT_APP_SHOW_REVIEW_TEST_TOOLS === "true";

const MAX_REVIEW_REQUESTS_PER_BATCH = 30;

  const [queue, setQueue] = useState([]);
  const [loading, setLoading] = useState(true);
const [reviewDailyUsage, setReviewDailyUsage] = useState({
  dailyLimit: 30,
  sentInLast24Hours: 0,
  remainingInLast24Hours: 30,
});
const [requests, setRequests] = useState([]);
const [requestsLoading, setRequestsLoading] = useState(true);
const [deleteRequestId, setDeleteRequestId] = useState(null);
const [deletingRequest, setDeletingRequest] = useState(false);
const [resendingRequestId, setResendingRequestId] = useState(null);
const [conversationModal, setConversationModal] = useState(false);
const [conversationLoading, setConversationLoading] = useState(false);
const [activeConversation, setActiveConversation] = useState(null);
const [conversationMessages, setConversationMessages] = useState([]);
const [adminReply, setAdminReply] = useState("");
const [sendingReply, setSendingReply] = useState(false);
const [customerSimulation, setCustomerSimulation] = useState("");
const [sendingCustomerSimulation, setSendingCustomerSimulation] = useState(false);
const [ratingSimulation, setRatingSimulation] = useState("");
const [sendingRatingSimulation, setSendingRatingSimulation] = useState(false);
const [productReviews, setProductReviews] = useState([]);
const [productReviewsLoading, setProductReviewsLoading] = useState(true);
const [updatingReviewId, setUpdatingReviewId] = useState(null);
const [mediaPreview, setMediaPreview] = useState(null);
const [reviewTextPreview, setReviewTextPreview] = useState(null);
const [manualResolveOptions, setManualResolveOptions] = useState([]);
const [manualResolveLoading, setManualResolveLoading] = useState(false);
const [manualResolveSaving, setManualResolveSaving] = useState(false);
const [selectedReviewMessageId, setSelectedReviewMessageId] = useState("");
const [selectedRatingMessageId, setSelectedRatingMessageId] = useState("");
const [selectedMediaMessageIds, setSelectedMediaMessageIds] = useState([]);
const [manualRating, setManualRating] = useState("");
const [manualReviewText, setManualReviewText] = useState("");
const [reviewPreset, setReviewPreset] = useState("");
const [runningAutoRating, setRunningAutoRating] = useState(false);
const [queueExpanded, setQueueExpanded] = useState(false);
const [requestsExpanded, setRequestsExpanded] = useState(false);
const [productReviewsExpanded, setProductReviewsExpanded] = useState(false);
const [requestStatusFilter, setRequestStatusFilter] = useState("all");
const [productReviewStatusFilter, setProductReviewStatusFilter] = useState("all");
  const [search, setSearch] = useState("");

  const [selected, setSelected] = useState({});
  const [language, setLanguage] = useState("EN");
const [sending, setSending] = useState(false);
const [toast, setToast] = useState(null);

  const TEXT = {
    EN: {
      title: "Reviews",
filter: "Filter",
all: "All",
sentFilter: "Sent",
completedFilter: "Completed",
waitingForRatingFilter: "Waiting for rating request",
needsAdminAttentionFilter: "Needs admin attention",
fullReview: "Full customer review",
hoverToRead: "Click to read the full review",
closePreview: "Close",
showMore: "Show more",
maxBatchLimit: "You can send a maximum of 30 review requests per day. Select all will choose only the remaining allowed number and skip duplicate customers.",
duplicateCustomerLimit:
  "This customer is already selected. You can only send one review request per customer in the same batch.",
bulkSelectionNote:
  "Bulk select respects the current daily limit and skips duplicate customers.",
showLess: "Show less",
      subtitle: "Collect and manage product reviews from paid orders.",
      requestQueue: "Review Request Queue",
      requestQueueDesc:
  "Paid order products that have not received a review request yet.",
      conversations: "Conversations",
      conversationsDesc: "WhatsApp customer replies will appear here later.",
      approvedReviews: "Approved Reviews",
actions: "Actions",
delete: "Delete",
viewConversation: "View conversation",
unexpectedResponse: "Unexpected response",
conversationTitle: "Review conversation",
conversationLoading: "Loading conversation...",
noMessages: "No messages yet.",
system: "ESIELL",
simulateRatingReply: "Simulate rating reply",
ratingReplyPlaceholder: "Write 1-5 or ⭐⭐⭐⭐⭐...",
ratingReplySaved: "Rating reply simulated successfully.",
customerLabel: "Customer",
adminLabel: "Admin",
step: "Step",
pendingReviews: "Pending Product Reviews",
pendingReviewsDesc:
  "Completed customer reviews waiting for admin approval before website display.",
reviewText: "Review",
approve: "Approve",
reject: "Reject",
approved: "Approved",
rejected: "Rejected",
pending: "Pending",
resend: "Resend",
resending: "Resending...",
resendRequestSent: "Review request resent successfully.",
resendAfter24h: "Resend available after 24h if customer did not reply.",
reviewUpdated: "Review status updated successfully.",
deleteRequestTitle: "Delete review request?",
deleteRequestText:
  "This will permanently delete this review request, its conversation, messages, and related product review. This product will not appear again in the review request queue.",
cancel: "Cancel",
manualResolve: "Manual resolve",
manualResolveDesc:
  "Select the customer's text and/or media, choose the rating, then create a pending product review. For voice-only reviews, select the voice notes and leave the review text empty.",
selectReviewMessage: "Select review message",
selectRatingMessage: "Select rating message",
selectMediaMessages: "Select media messages",
manualRating: "Manual rating",
manualReviewText: "Manual review text",
reviewPreset: "Review preset",
chooseOption: "Choose option",
saveAsPendingReview: "Save as pending review",
manualResolveSaved: "Review moved to pending product reviews successfully.",
runAutoRating: "Run auto-rating",
autoRatingDone: "Auto-rating check completed.",
useMessage: "Use message",
useRating: "Use rating",
useMedia: "Use media",
noEligibleMessages: "No eligible customer messages yet.",
confirmDelete: "Delete",
      approvedReviewsDesc: "Website product reviews will appear here later.",
      search: "Search by customer, order, product, or phone...",
      language: "Language",
replyPlaceholder: "Write a manual reply to the customer...",
sendReply: "Send reply",
replySaved: "Reply saved successfully.",
      english: "English",
      arabic: "Arabic",
      sendSelected: "Send selected",
      selected: "selected",
      customer: "Customer",
      order: "Order",
      product: "Product",
      variant: "Variant",
      phone: "Phone",
simulateCustomerReply: "Simulate customer reply",
customerReplyPlaceholder: "Write a test customer reply...",
customerReplySaved: "Customer reply simulated successfully.",
      status: "Status",
      notSent: "Not sent",
      loading: "Loading review request queue...",
      empty: "No delivered products waiting for review requests.",
      qty: "Qty",
      comingSoon: "Coming soon",
    },
    AR: {
      title: "المراجعات",
replyPlaceholder: "اكتب رداً يدوياً للعميل...",
sendReply: "إرسال الرد",
replySaved: "تم حفظ الرد بنجاح.",
      subtitle: "جمع وإدارة مراجعات المنتجات من الطلبات المدفوعة.",
      requestQueue: "طلبات المراجعة",
showMore: "عرض المزيد",
maxBatchLimit: "يمكن إرسال 30 طلب مراجعة كحد أقصى في اليوم. زر تحديد الكل سيختار فقط العدد المتبقي المسموح ويتخطى العملاء المكررين.",
duplicateCustomerLimit:
  "هذا العميل محدد بالفعل. يمكن إرسال طلب مراجعة واحد فقط لكل عميل في نفس الدفعة.",
bulkSelectionNote:
  "التحديد الجماعي يلتزم بالحد اليومي الحالي ويتخطى العملاء المكررين.",
showLess: "عرض أقل",
filter: "تصفية",
all: "الكل",
fullReview: "مراجعة العميل كاملة",
hoverToRead: "اضغط لقراءة المراجعة كاملة",
closePreview: "إغلاق",
resend: "إعادة إرسال",
resending: "جاري الإرسال...",
resendRequestSent: "تمت إعادة إرسال طلب المراجعة بنجاح.",
resendAfter24h: "إعادة الإرسال متاحة بعد 24 ساعة إذا لم يرد العميل.",
sentFilter: "مرسل",
manualResolve: "حل يدوي",
manualResolveDesc:
  "اختر نص العميل و/أو الوسائط وحدد التقييم، ثم أنشئ مراجعة قيد الانتظار. للمراجعات الصوتية فقط، اختر التسجيلات الصوتية واترك نص المراجعة فارغاً.",
selectReviewMessage: "اختر رسالة المراجعة",
selectRatingMessage: "اختر رسالة التقييم",
selectMediaMessages: "اختر الوسائط",
manualRating: "تقييم يدوي",
manualReviewText: "نص مراجعة يدوي",
reviewPreset: "نص مراجعة جاهز",
chooseOption: "اختر",
saveAsPendingReview: "حفظ كمراجعة قيد الانتظار",
manualResolveSaved: "تم نقل المراجعة إلى مراجعات المنتجات قيد الانتظار بنجاح.",
runAutoRating: "تشغيل التقييم التلقائي",
autoRatingDone: "تم فحص التقييم التلقائي.",
useMessage: "استخدام الرسالة",
useRating: "استخدام التقييم",
useMedia: "استخدام الوسائط",
noEligibleMessages: "لا توجد رسائل عميل مناسبة بعد.",
completedFilter: "مكتمل",
waitingForRatingFilter: "بانتظار طلب التقييم",
needsAdminAttentionFilter: "يحتاج متابعة الإدارة",
      requestQueueDesc:
  "منتجات الطلبات المدفوعة التي لم يتم إرسال طلب مراجعة لها بعد.",
      conversations: "المحادثات",
      conversationsDesc: "ستظهر ردود العملاء عبر واتساب هنا لاحقًا.",
      approvedReviews: "المراجعات المقبولة",
unexpectedResponse: "رد غير متوقع",
      approvedReviewsDesc: "ستظهر مراجعات المنتجات المنشورة هنا لاحقًا.",
      search: "بحث بالعميل أو الطلب أو المنتج أو الهاتف...",
      language: "اللغة",
pendingReviews: "مراجعات المنتجات",
pendingReviewsDesc:
  "مراجعات العملاء المكتملة بانتظار موافقة الإدارة قبل عرضها على الموقع.",
reviewText: "المراجعة",
approve: "قبول",
reject: "رفض",
approved: "مقبولة",
rejected: "مرفوضة",
pending: "قيد الانتظار",
reviewUpdated: "تم تحديث حالة المراجعة بنجاح.",
actions: "الإجراءات",
delete: "حذف",
simulateRatingReply: "محاكاة تقييم العميل",
ratingReplyPlaceholder: "اكتب رقم من 1 إلى 5 أو ⭐⭐⭐⭐⭐...",
ratingReplySaved: "تمت محاكاة تقييم العميل بنجاح.",
viewConversation: "عرض المحادثة",
simulateCustomerReply: "محاكاة رد العميل",
customerReplyPlaceholder: "اكتب رد عميل تجريبي...",
customerReplySaved: "تمت محاكاة رد العميل بنجاح.",
conversationTitle: "محادثة المراجعة",
conversationLoading: "جاري تحميل المحادثة...",
noMessages: "لا توجد رسائل بعد.",
system: "ESIELL",
customerLabel: "العميل",
adminLabel: "الإدارة",
step: "المرحلة",
deleteRequestTitle: "حذف طلب المراجعة؟",
deleteRequestText:
  "سيتم حذف طلب المراجعة والمحادثة والرسائل والمراجعة المرتبطة به نهائياً. لن يظهر هذا المنتج مرة أخرى في قائمة طلبات المراجعة.",
cancel: "إلغاء",
confirmDelete: "حذف",
      english: "الإنجليزية",
      arabic: "العربية",
      sendSelected: "إرسال المحدد",
      selected: "محدد",
      customer: "العميل",
      order: "الطلب",
      product: "المنتج",
      variant: "الموديل",
      phone: "الهاتف",
      status: "الحالة",
      notSent: "لم يرسل",
      loading: "جاري تحميل طلبات المراجعة...",
      empty: "لا توجد منتجات مسلّمة بانتظار طلب مراجعة.",
      qty: "الكمية",
      comingSoon: "قريبًا",
    },
  }[lang];

useEffect(() => {
  if (!reviewTextPreview) return;

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setReviewTextPreview(null);
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [reviewTextPreview]);

 useEffect(() => {
  let mounted = true;

  setLoading(true);
  setRequestsLoading(true);
  setProductReviewsLoading(true);

  Promise.all([
  getReviewRequestQueue(),
  getReviewRequests(),
  getProductReviews(),
  getReviewManualResolveOptions(),
])
    .then(([queueData, requestsData, reviewsData, resolveOptionsData]) => {
      if (!mounted) return;

      setQueue(Array.isArray(queueData.items) ? queueData.items : []);
setReviewDailyUsage({
  dailyLimit: Number(queueData.dailyLimit || 30),
  sentInLast24Hours: Number(queueData.sentInLast24Hours || 0),
  remainingInLast24Hours: Number(
    queueData.remainingInLast24Hours ?? 30
  ),
});
      setRequests(
        Array.isArray(requestsData.requests) ? requestsData.requests : []
      );
      setProductReviews(
        Array.isArray(reviewsData.reviews) ? reviewsData.reviews : []
      );
setManualResolveOptions(
  Array.isArray(resolveOptionsData.reviewTextPresets)
    ? resolveOptionsData.reviewTextPresets
    : []
);
    })
    .catch((err) => {
      console.error(err);
      if (mounted) {
        setQueue([]);
        setRequests([]);
        setProductReviews([]);
      }
    })
    .finally(() => {
      if (mounted) {
        setLoading(false);
        setRequestsLoading(false);
        setProductReviewsLoading(false);
      }
    });

  return () => {
    mounted = false;
  };
}, []);

const loadProductReviews = () => {
  setProductReviewsLoading(true);

  return getProductReviews()
    .then((data) => {
      setProductReviews(Array.isArray(data.reviews) ? data.reviews : []);
    })
    .catch((err) => {
      console.error(err);
      setProductReviews([]);
    })
    .finally(() => {
      setProductReviewsLoading(false);
    });
};

const loadRequests = () => {
  setRequestsLoading(true);

  return getReviewRequests()
    .then((data) => {
      setRequests(Array.isArray(data.requests) ? data.requests : []);
    })
    .catch((err) => {
      console.error(err);
      setRequests([]);
    })
    .finally(() => {
      setRequestsLoading(false);
    });
};

const matchesRequestStatusFilter = (item) => {
  if (requestStatusFilter === "all") return true;

  if (requestStatusFilter === "sent") {
  return (
    item.needsAdminAttention !== true &&
    ["sent", "delivered"].includes(item.status)
  );
}

  if (requestStatusFilter === "completed") {
  return (
    item.needsAdminAttention !== true &&
    item.status === "completed"
  );
}

  if (requestStatusFilter === "rating_requested") {
  return (
    item.needsAdminAttention !== true &&
    item.status === "rating_requested"
  );
}

  if (requestStatusFilter === "needs_admin_attention") {
  return (
    item.status === "needs_admin_attention" ||
    item.needsAdminAttention === true
  );
}

  return true;
};

const matchesProductReviewStatusFilter = (item) => {
  if (productReviewStatusFilter === "all") return true;
  return item.status === productReviewStatusFilter;
};

const normalizeCustomerSelectionValue = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/\s/g, "")
    .replace(/\+/g, "")
    .replace(/-/g, "")
    .trim();

const getCustomerSelectionKey = (item) => {
  const phone = normalizeCustomerSelectionValue(item.customerPhone);

  if (phone) {
    return `phone:${phone}`;
  }

  const email = normalizeCustomerSelectionValue(item.customerEmail);

  if (email) {
    return `email:${email}`;
  }

  return `name:${normalizeCustomerSelectionValue(item.customerName)}`;
};

const getCurrentSelectionLimit = () =>
  Math.max(
    0,
    Math.min(
      MAX_REVIEW_REQUESTS_PER_BATCH,
      Number(reviewDailyUsage.remainingInLast24Hours || 0)
    )
  );

const getDailyAllowanceError = () => {
  if (reviewDailyUsage.remainingInLast24Hours <= 0) {
    return lang === "EN"
      ? "The limit of 30 new review requests during 24 hours has been reached."
      : "تم الوصول إلى الحد الأقصى وهو 30 طلب مراجعة جديد خلال 24 ساعة.";
  }

  return lang === "EN"
    ? `Only ${reviewDailyUsage.remainingInLast24Hours} request(s) remain available during the current 24-hour period.`
    : `يتبقى ${reviewDailyUsage.remainingInLast24Hours} طلب مراجعة فقط خلال فترة الـ24 ساعة الحالية.`;
};

const getSelectableUniqueCustomers = (items) => {
  const seenCustomers = new Set();
  const result = [];
  const currentSelectionLimit = getCurrentSelectionLimit();

  if (currentSelectionLimit <= 0) {
    return result;
  }

  for (const item of items) {
    const customerKey = getCustomerSelectionKey(item);

    if (!customerKey || seenCustomers.has(customerKey)) {
      continue;
    }

    seenCustomers.add(customerKey);
    result.push(item);

    if (result.length >= currentSelectionLimit) {
      break;
    }
  }

  return result;
};

const matchesReviewSearch = (item, s) => {
  if (!s) return true;

  return (
    String(item.orderNumber || "").toLowerCase().includes(s) ||
    String(item.customerName || "").toLowerCase().includes(s) ||
    String(item.customerPhone || "").toLowerCase().includes(s) ||
    String(item.customerEmail || "").toLowerCase().includes(s) ||
    String(item.productNameEn || "").toLowerCase().includes(s) ||
    String(item.productNameAr || "").toLowerCase().includes(s) ||
    String(item.publicId || "").toLowerCase().includes(s) ||
    String(item.status || "").toLowerCase().includes(s) ||
    String(item.language || "").toLowerCase().includes(s) ||
    String(item.reviewText || "").toLowerCase().includes(s)
  );
};

  const filtered = useMemo(() => {
  const s = search.trim().toLowerCase();
  return queue.filter((item) => matchesReviewSearch(item, s));
}, [queue, search]);

const filteredRequests = useMemo(() => {
  const s = search.trim().toLowerCase();

  return requests.filter(
    (item) => matchesReviewSearch(item, s) && matchesRequestStatusFilter(item)
  );
}, [requests, search, requestStatusFilter]);

const filteredProductReviews = useMemo(() => {
  const s = search.trim().toLowerCase();

  return productReviews.filter(
    (item) =>
      matchesReviewSearch(item, s) && matchesProductReviewStatusFilter(item)
  );
}, [productReviews, search, productReviewStatusFilter]);

const visibleQueue = queueExpanded ? filtered : filtered.slice(0, 6);
const visibleRequests = requestsExpanded
  ? filteredRequests
  : filteredRequests.slice(0, 6);
const visibleProductReviews = productReviewsExpanded
  ? filteredProductReviews
  : filteredProductReviews.slice(0, 6);

  const selectedQueueItems = useMemo(() => {
  return queue.filter((item) => selected[item.orderItemId]);
}, [queue, selected]);

const selectedIds = selectedQueueItems.map((item) => String(item.orderItemId));

const selectedCustomerKeys = useMemo(() => {
  return new Set(selectedQueueItems.map((item) => getCustomerSelectionKey(item)));
}, [selectedQueueItems]);

  const toggleOne = (orderItemId) => {
  const item = queue.find(
    (queueItem) => String(queueItem.orderItemId) === String(orderItemId)
  );

  if (!item) return;

  const isCurrentlySelected = !!selected[orderItemId];

  if (isCurrentlySelected) {
    setSelected((prev) => {
      const next = { ...prev };
      delete next[orderItemId];
      return next;
    });
    return;
  }

  const currentSelectionLimit = getCurrentSelectionLimit();

if (currentSelectionLimit <= 0) {
  setToast({
    type: "error",
    message:
      lang === "EN"
        ? "The limit of 30 new review requests during 24 hours has been reached."
        : "تم الوصول إلى الحد الأقصى وهو 30 طلب مراجعة جديد خلال 24 ساعة.",
  });

  setTimeout(() => setToast(null), 3500);
  return;
}

if (selectedIds.length >= currentSelectionLimit) {
  setToast({
    type: "error",
    message:
      currentSelectionLimit < MAX_REVIEW_REQUESTS_PER_BATCH
        ? getDailyAllowanceError()
        : TEXT.maxBatchLimit,
  });

  setTimeout(() => setToast(null), 3500);
  return;
}

  const customerKey = getCustomerSelectionKey(item);

  if (selectedCustomerKeys.has(customerKey)) {
    setToast({
      type: "error",
      message: TEXT.duplicateCustomerLimit,
    });

    setTimeout(() => setToast(null), 3500);
    return;
  }

  setSelected((prev) => ({
    ...prev,
    [orderItemId]: true,
  }));
};

  const toggleAllFiltered = () => {
  const currentSelectionLimit = getCurrentSelectionLimit();

  if (currentSelectionLimit <= 0) {
    setSelected({});

    setToast({
      type: "error",
      message: getDailyAllowanceError(),
    });

    setTimeout(() => setToast(null), 3500);
    return;
  }

  const bulkItems = getSelectableUniqueCustomers(filtered);

  const bulkIds = bulkItems.map((item) => String(item.orderItemId));

  const allBulkSelected =
    bulkIds.length > 0 &&
    bulkIds.every((id) => selected[id]) &&
    selectedIds.length === bulkIds.length;

  if (allBulkSelected) {
    setSelected({});
    return;
  }

  const next = {};

  bulkItems.forEach((item) => {
    next[item.orderItemId] = true;
  });

  setSelected(next);

  setToast({
    type: "success",
    message:
      lang === "EN"
        ? `${bulkItems.length} request(s) selected. ${TEXT.bulkSelectionNote}`
        : `تم تحديد ${bulkItems.length} طلب. ${TEXT.bulkSelectionNote}`,
  });

  setTimeout(() => setToast(null), 3000);
};

  const handleSendSelected = async () => {
  if (selectedIds.length === 0 || sending) return;

  const currentSelectionLimit = getCurrentSelectionLimit();

  if (currentSelectionLimit <= 0) {
    setToast({
      type: "error",
      message: getDailyAllowanceError(),
    });

    setTimeout(() => setToast(null), 3500);
    return;
  }

  if (selectedQueueItems.length > currentSelectionLimit) {
    setToast({
      type: "error",
      message: getDailyAllowanceError(),
    });

    setTimeout(() => setToast(null), 3500);
    return;
  }

  try {
    setSending(true);

    if (selectedQueueItems.length > MAX_REVIEW_REQUESTS_PER_BATCH) {
  setToast({
    type: "error",
    message: TEXT.maxBatchLimit,
  });

  setTimeout(() => setToast(null), 3500);
  return;
}

const uniqueCustomerKeys = new Set(
  selectedQueueItems.map((item) => getCustomerSelectionKey(item))
);

if (uniqueCustomerKeys.size !== selectedQueueItems.length) {
  setToast({
    type: "error",
    message: TEXT.duplicateCustomerLimit,
  });

  setTimeout(() => setToast(null), 3500);
  return;
}

const safeSelectedIds = selectedQueueItems.map((item) => item.orderItemId);

const res = await sendReviewRequests({
  orderItemIds: safeSelectedIds,
  language,
});

setReviewDailyUsage({
  dailyLimit: Number(res.dailyLimit || 30),
  sentInLast24Hours: Number(res.sentInLast24Hours || 0),
  remainingInLast24Hours: Number(
    res.remainingInLast24Hours ?? 0
  ),
});

    const selectedSet = new Set(safeSelectedIds.map((id) => Number(id)));

    setQueue((prev) =>
      prev.filter((item) => !selectedSet.has(Number(item.orderItemId)))
    );

    setSelected({});
await loadRequests();

    setToast({
      type: "success",
      message:
        lang === "EN"
          ? `${res.created || 0} review request(s) created successfully.`
          : `تم إنشاء ${res.created || 0} طلب مراجعة بنجاح.`,
    });

    setTimeout(() => setToast(null), 3000);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to create review requests."
          : "فشل إنشاء طلبات المراجعة."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setSending(false);
  }
};

  const formatDate = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleDateString(lang === "AR" ? "ar" : "en", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const selectedCount = selectedIds.length;
 const bulkSelectableItems = getSelectableUniqueCustomers(filtered);

const allFilteredSelected =
  bulkSelectableItems.length > 0 &&
  bulkSelectableItems.every((item) => selected[item.orderItemId]) &&
  selectedIds.length === bulkSelectableItems.length;

const getRequestDisplayStatus = (item) => {
  if (item?.needsAdminAttention === true) {
    return "needs_admin_attention";
  }

  return item?.status || "pending";
};

const statusBadge = (status) => {
  switch (status) {
    case "pending":
      return "bg-orange-50 text-orange-700 border-orange-100";
    case "sent":
      return "bg-blue-50 text-blue-700 border-blue-100";
    case "delivered":
      return "bg-cyan-50 text-cyan-700 border-cyan-100";
    case "replied":
      return "bg-purple-50 text-purple-700 border-purple-100";
    case "rating_requested":
      return "bg-indigo-50 text-indigo-700 border-indigo-100";
    case "completed":
      return "bg-green-50 text-green-700 border-green-100";
    case "needs_admin_attention":
      return "bg-red-50 text-red-700 border-red-100";
    case "failed":
      return "bg-red-50 text-red-700 border-red-100";
    default:
      return "bg-gray-50 text-gray-600 border-gray-100";
  }
};

const getRequestStatusLabel = (item) => {
  const status = getRequestDisplayStatus(item);

  if (status === "needs_admin_attention") {
    return TEXT.needsAdminAttentionFilter;
  }

  if (status === "rating_requested") {
    return TEXT.waitingForRatingFilter;
  }

  if (status === "completed") {
    return TEXT.completedFilter;
  }

  if (status === "sent" || status === "delivered") {
    return TEXT.sentFilter;
  }

  return status;
};

const canDeleteRequest = () => true;

const canResendRequest = (item) => {
  if (!item || item.repliedAt) return false;

  if (!["sent", "delivered", "failed"].includes(item.status)) {
    return false;
  }

  if (!item.sentAt) {
    return item.status === "failed";
  }

  const sentTime = new Date(item.sentAt).getTime();

  if (!sentTime) return false;

  return Date.now() - sentTime >= 24 * 60 * 60 * 1000;
};

const handleResendRequest = async (requestId) => {
  if (!requestId || resendingRequestId) return;

  try {
    setResendingRequestId(requestId);

    await resendReviewRequest(requestId);

    await loadRequests();

    setToast({
      type: "success",
      message: TEXT.resendRequestSent,
    });

    setTimeout(() => setToast(null), 3500);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to resend review request."
          : "فشل إعادة إرسال طلب المراجعة."),
    });

    setTimeout(() => setToast(null), 4500);
  } finally {
    setResendingRequestId(null);
  }
};

const confirmDeleteRequest = async () => {
  if (!deleteRequestId || deletingRequest) return;

  try {
    setDeletingRequest(true);

    await deleteReviewRequest(deleteRequestId);

    await Promise.all([
      getReviewRequestQueue().then((data) => {
        setQueue(Array.isArray(data.items) ? data.items : []);
      }),
      loadRequests(),
    ]);

    setToast({
      type: "success",
      message:
        lang === "EN"
          ? "Review request deleted successfully."
          : "تم حذف طلب المراجعة بنجاح.",
    });

    setTimeout(() => setToast(null), 3000);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to delete review request."
          : "فشل حذف طلب المراجعة."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setDeletingRequest(false);
    setDeleteRequestId(null);
  }
};

const openConversation = async (requestId) => {
  try {
    setConversationModal(true);
    setConversationLoading(true);
    setActiveConversation(null);
    setConversationMessages([]);
    setAdminReply("");
    setCustomerSimulation("");
    setRatingSimulation("");
setSelectedReviewMessageId("");
setSelectedRatingMessageId("");
setSelectedMediaMessageIds([]);
setManualRating("");
setManualReviewText("");
setReviewPreset("");

    const data = await getReviewConversation(requestId);

    setActiveConversation(data.conversation || null);
    setConversationMessages(Array.isArray(data.messages) ? data.messages : []);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to load conversation."
          : "فشل تحميل المحادثة."),
    });

    setTimeout(() => setToast(null), 4000);
    setConversationModal(false);
  } finally {
    setConversationLoading(false);
  }
};

const formatDateTime = (date) => {
  if (!date) return "—";

  return new Date(date).toLocaleString(lang === "AR" ? "ar" : "en", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const messageSenderLabel = (msg) => {
  if (msg.senderType === "customer") return TEXT.customerLabel;
  if (msg.senderType === "admin") return TEXT.adminLabel;
  return TEXT.system;
};

const customerTextMessages = useMemo(() => {
  return conversationMessages.filter(
    (msg) =>
      msg.direction === "inbound" &&
      msg.senderType === "customer" &&
      msg.messageType === "text" &&
      String(msg.body || "").trim()
  );
}, [conversationMessages]);

const customerRatingMessages = useMemo(() => {
  return conversationMessages.filter(
    (msg) =>
      msg.direction === "inbound" &&
      msg.senderType === "customer" &&
      (msg.messageType === "rating" || msg.rating)
  );
}, [conversationMessages]);

const customerMediaMessages = useMemo(() => {
  return conversationMessages.filter(
    (msg) =>
      msg.direction === "inbound" &&
      msg.senderType === "customer" &&
      ["image", "audio", "video"].includes(msg.messageType) &&
      msg.mediaUrl
  );
}, [conversationMessages]);

const toggleSelectedMediaMessage = (messageId) => {
  const id = Number(messageId);

  setSelectedMediaMessageIds((prev) => {
    if (prev.includes(id)) {
      return prev.filter((item) => item !== id);
    }

    return [...prev, id];
  });
};

const handleRunAutoRating = async () => {
  if (runningAutoRating) return;

  try {
    setRunningAutoRating(true);

    const res = await runReviewAutoRating();

    await loadRequests();
    await loadProductReviews();

    setToast({
      type: "success",
      message:
        lang === "EN"
          ? `${TEXT.autoRatingDone} Completed: ${res.completed || 0}`
          : `${TEXT.autoRatingDone} المكتملة: ${res.completed || 0}`,
    });

    setTimeout(() => setToast(null), 3500);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to run auto-rating."
          : "فشل تشغيل التقييم التلقائي."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setRunningAutoRating(false);
  }
};

const handleManualResolve = async () => {
  if (!activeConversation?.reviewRequestId || manualResolveSaving) return;

  const ratingValue = manualRating ? Number(manualRating) : null;

  if (!selectedRatingMessageId && (!ratingValue || ratingValue < 1 || ratingValue > 5)) {
    setToast({
      type: "error",
      message:
        lang === "EN"
          ? "Please select a rating message or enter a manual rating from 1 to 5."
          : "يرجى اختيار رسالة تقييم أو إدخال تقييم يدوي من 1 إلى 5.",
    });

    setTimeout(() => setToast(null), 3500);
    return;
  }

  const hasSelectedMedia =
  Array.isArray(selectedMediaMessageIds) &&
  selectedMediaMessageIds.length > 0;

if (
  !selectedReviewMessageId &&
  !manualReviewText.trim() &&
  !reviewPreset.trim() &&
  !hasSelectedMedia
) {
  setToast({
    type: "error",
    message:
      lang === "EN"
        ? "Please select a review message, select review media, or choose/write review text."
        : "يرجى اختيار رسالة مراجعة أو وسائط مراجعة أو اختيار/كتابة نص للمراجعة.",
  });

  setTimeout(() => setToast(null), 3500);
  return;
}

  try {
    setManualResolveSaving(true);

    await resolveReviewManually({
      id: activeConversation.reviewRequestId,
      selectedReviewMessageId: selectedReviewMessageId || null,
      selectedRatingMessageId: selectedRatingMessageId || null,
      selectedMediaMessageIds,
      manualRating: ratingValue,
      manualReviewText,
      reviewPreset,
    });

    const data = await getReviewConversation(activeConversation.reviewRequestId);

    setActiveConversation(data.conversation || null);
    setConversationMessages(Array.isArray(data.messages) ? data.messages : []);

    setSelectedReviewMessageId("");
    setSelectedRatingMessageId("");
    setSelectedMediaMessageIds([]);
    setManualRating("");
    setManualReviewText("");
    setReviewPreset("");

    await loadRequests();
    await loadProductReviews();

    setToast({
      type: "success",
      message: TEXT.manualResolveSaved,
    });

    setTimeout(() => setToast(null), 3500);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to manually resolve review."
          : "فشل حل المراجعة يدوياً."),
    });

    setTimeout(() => setToast(null), 4500);
  } finally {
    setManualResolveSaving(false);
  }
};

const handleSendAdminReply = async () => {
  if (!activeConversation?.reviewRequestId || sendingReply) return;

  const body = adminReply.trim();

  if (!body) {
    setToast({
      type: "error",
      message:
        lang === "EN"
          ? "Please write a reply first."
          : "يرجى كتابة الرد أولاً.",
    });

    setTimeout(() => setToast(null), 3000);
    return;
  }

  try {
    setSendingReply(true);

    await sendAdminReviewReply({
      id: activeConversation.reviewRequestId,
      body,
    });

    const data = await getReviewConversation(activeConversation.reviewRequestId);

    setActiveConversation(data.conversation || null);
    setConversationMessages(Array.isArray(data.messages) ? data.messages : []);
    setAdminReply("");

    await loadRequests();

    setToast({
      type: "success",
      message: TEXT.replySaved,
    });

    setTimeout(() => setToast(null), 3000);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to save reply."
          : "فشل حفظ الرد."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setSendingReply(false);
  }
};

const handleSimulateCustomerReply = async () => {
  if (!activeConversation?.reviewRequestId || sendingCustomerSimulation) return;

  const body = customerSimulation.trim();

  if (!body) {
    setToast({
      type: "error",
      message:
        lang === "EN"
          ? "Please write a customer reply first."
          : "يرجى كتابة رد العميل أولاً.",
    });

    setTimeout(() => setToast(null), 3000);
    return;
  }

  try {
    setSendingCustomerSimulation(true);

    await simulateCustomerReviewReply({
      id: activeConversation.reviewRequestId,
      body,
    });

    const data = await getReviewConversation(activeConversation.reviewRequestId);

    setActiveConversation(data.conversation || null);
    setConversationMessages(Array.isArray(data.messages) ? data.messages : []);
    setCustomerSimulation("");

    await loadRequests();

    setToast({
      type: "success",
      message: TEXT.customerReplySaved,
    });

    setTimeout(() => setToast(null), 3000);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to simulate customer reply."
          : "فشل محاكاة رد العميل."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setSendingCustomerSimulation(false);
  }
};

const handleSimulateRatingReply = async () => {
  if (!activeConversation?.reviewRequestId || sendingRatingSimulation) return;

  const body = ratingSimulation.trim();

  if (!body) {
    setToast({
      type: "error",
      message:
        lang === "EN"
          ? "Please write a rating first."
          : "يرجى كتابة التقييم أولاً.",
    });

    setTimeout(() => setToast(null), 3000);
    return;
  }

  try {
    setSendingRatingSimulation(true);

    const res = await simulateCustomerRatingReply({
      id: activeConversation.reviewRequestId,
      body,
    });

    const data = await getReviewConversation(activeConversation.reviewRequestId);

    setActiveConversation(data.conversation || null);
    setConversationMessages(Array.isArray(data.messages) ? data.messages : []);
    setRatingSimulation("");

    await loadRequests();
    await loadProductReviews();

    setToast({
      type: res.needsAdminAttention ? "error" : "success",
      message: res.needsAdminAttention
        ? lang === "EN"
          ? "Rating was not recognized. Admin attention is required."
          : "لم يتم التعرف على التقييم. يحتاج إلى متابعة من الإدارة."
        : TEXT.ratingReplySaved,
    });

    setTimeout(() => setToast(null), 4000);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to simulate rating reply."
          : "فشل محاكاة تقييم العميل."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setSendingRatingSimulation(false);
  }
};

const productReviewStatusBadge = (status) => {
  switch (status) {
    case "approved":
      return "bg-green-50 text-green-700 border-green-100";
    case "rejected":
      return "bg-red-50 text-red-700 border-red-100";
    case "pending":
      return "bg-orange-50 text-orange-700 border-orange-100";
    default:
      return "bg-gray-50 text-gray-600 border-gray-100";
  }
};

const productReviewStatusLabel = (status) => {
  if (status === "approved") return TEXT.approved;
  if (status === "rejected") return TEXT.rejected;
  return TEXT.pending;
};

const handleUpdateProductReviewStatus = async (reviewId, status) => {
  if (updatingReviewId) return;

  try {
    setUpdatingReviewId(reviewId);

    await updateProductReviewStatus({
      id: reviewId,
      status,
    });

    await loadProductReviews();

    setToast({
      type: "success",
      message: TEXT.reviewUpdated,
    });

    setTimeout(() => setToast(null), 3000);
  } catch (err) {
    console.error(err);

    setToast({
      type: "error",
      message:
        err.message ||
        (lang === "EN"
          ? "Failed to update review status."
          : "فشل تحديث حالة المراجعة."),
    });

    setTimeout(() => setToast(null), 4000);
  } finally {
    setUpdatingReviewId(null);
  }
};

const renderReviewMedia = (review, mode = "table") => {
  const mediaItems =
    Array.isArray(review.reviewMediaItems) &&
    review.reviewMediaItems.length > 0
      ? review.reviewMediaItems.filter(
          (item) => item?.url && item?.type
        )
      : review.reviewMediaUrl && review.reviewMediaType
      ? [
          {
            id: `legacy-${review.id}`,
            url: review.reviewMediaUrl,
            type: review.reviewMediaType,
            mimeType: review.reviewMediaMimeType || null,
            filename: review.reviewMediaFilename || null,
          },
        ]
      : [];

  if (mediaItems.length === 0) return null;

  const title =
    lang === "AR"
      ? review.productNameAr ||
        review.productNameEn ||
        "Review media"
      : review.productNameEn ||
        review.productNameAr ||
        "Review media";

  const openMediaPreview = (media) => {
    setMediaPreview({
      url: media.url,
      type: media.type,
      mime: media.mimeType || null,
      title,
    });
  };

  const renderMediaItem = (media, index) => {
    const key =
      media.id || `${review.id}-${media.type}-${index}`;

    if (media.type === "image") {
      return (
        <div key={key}>
          <button
            type="button"
            onClick={() => openMediaPreview(media)}
            className="block w-full"
          >
            <img
              src={media.url}
              alt={`Customer review ${index + 1}`}
              loading="lazy"
              className={
                mode === "mobile"
                  ? "h-52 w-full object-contain rounded-xl border bg-white"
                  : "h-24 w-full object-cover rounded-xl border bg-white"
              }
            />
          </button>

          <button
            type="button"
            onClick={() => openMediaPreview(media)}
            className="mt-2 inline-flex items-center justify-center px-3 py-1.5 rounded-xl text-xs font-semibold bg-cyan-50 text-cyan-700 hover:bg-cyan-100 transition"
          >
            {lang === "EN" ? "Open image" : "عرض الصورة"}
          </button>
        </div>
      );
    }

    if (media.type === "video") {
      return (
        <div key={key}>
          <video
            controls
            playsInline
            preload="metadata"
            className={
              mode === "mobile"
                ? "h-52 w-full object-contain rounded-xl border bg-black"
                : "h-28 w-full object-contain rounded-xl border bg-black"
            }
          >
            <source
              src={media.url}
              type={media.mimeType || "video/mp4"}
            />
          </video>

          <button
            type="button"
            onClick={() => openMediaPreview(media)}
            className="mt-2 inline-flex items-center justify-center px-3 py-1.5 rounded-xl text-xs font-semibold bg-cyan-50 text-cyan-700 hover:bg-cyan-100 transition"
          >
            {lang === "EN" ? "Open video" : "عرض الفيديو"}
          </button>
        </div>
      );
    }

    if (media.type === "audio") {
      return (
        <div
          key={key}
          className="rounded-xl border bg-gray-50 p-3"
        >
          <p className="text-xs text-gray-500 mb-2">
            {lang === "EN"
              ? `Voice review ${index + 1}`
              : `مراجعة صوتية ${index + 1}`}
          </p>

          <audio
            controls
            preload="metadata"
            className="w-full"
          >
            <source
              src={media.url}
              type={media.mimeType || "audio/ogg"}
            />
          </audio>

          <button
            type="button"
            onClick={() => openMediaPreview(media)}
            className="mt-2 inline-flex items-center justify-center px-3 py-1.5 rounded-xl text-xs font-semibold bg-cyan-50 text-cyan-700 hover:bg-cyan-100 transition"
          >
            {lang === "EN"
              ? "Open voice review"
              : "عرض المراجعة الصوتية"}
          </button>
        </div>
      );
    }

    return (
      <a
        key={key}
        href={media.url}
        target="_blank"
        rel="noreferrer"
        className="block rounded-xl border bg-gray-50 p-3 text-cyan-700 underline text-xs"
      >
        {media.filename ||
          (lang === "EN"
            ? "Open review media"
            : "عرض وسائط المراجعة")}
      </a>
    );
  };

  return (
    <div
      className={`mt-3 grid gap-3 ${
        mode === "mobile"
          ? mediaItems.length === 1
            ? "grid-cols-1"
            : "grid-cols-1 sm:grid-cols-2"
          : mediaItems.length === 1
          ? "grid-cols-1 max-w-[180px]"
          : "grid-cols-2 max-w-[360px]"
      }`}
    >
      {mediaItems.map((media, index) =>
        renderMediaItem(media, index)
      )}
    </div>
  );
};

  return (
    <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="flex-1 lg:ml-64 w-full transition-all duration-300">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6 animate-fadeSlide">
          {/* HEADER */}
          <div className="mb-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div>
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-2xl bg-cyan-100 text-cyan-700 flex items-center justify-center">
                    <FaStar />
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-cyan-700">
                      {TEXT.title}
                    </h1>
                    <p className="text-sm text-gray-500 mt-1">
                      {TEXT.subtitle}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white border rounded-2xl shadow-sm px-4 py-3 flex flex-col sm:flex-row gap-3 sm:items-center">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <FaLanguage className="text-cyan-600" />
                  <span>{TEXT.language}</span>
                </div>

                <select
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  className="border rounded-xl px-3 py-2 text-sm bg-white"
                >
                  <option value="EN">{TEXT.english}</option>
                  <option value="AR">{TEXT.arabic}</option>
                </select>

<button
  onClick={handleSendSelected}
  disabled={
  selectedCount === 0 ||
  sending ||
  reviewDailyUsage.remainingInLast24Hours <= 0
}
                  className={`
                    inline-flex items-center justify-center gap-2
                    px-4 py-2 rounded-xl text-sm font-semibold transition
                    ${
                      selectedCount === 0 ||
reviewDailyUsage.remainingInLast24Hours <= 0
                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-700 shadow"
                    }
                  `}
                >
                  <FaPaperPlane />
                  {sending
  ? lang === "EN"
    ? "Creating..."
    : "جاري الإنشاء..."
  : TEXT.sendSelected}
                  {selectedCount > 0 && (
                    <span className="bg-white/20 px-2 py-0.5 rounded-full">
                      {selectedCount}
                    </span>
                  )}
                </button>
<button
  type="button"
  onClick={handleRunAutoRating}
  disabled={runningAutoRating}
  className={`
    inline-flex items-center justify-center gap-2
    px-4 py-2 rounded-xl text-sm font-semibold transition
    ${
      runningAutoRating
        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
        : "bg-indigo-600 text-white hover:bg-indigo-700 shadow"
    }
  `}
>
  <FaStar />
  {runningAutoRating
    ? lang === "EN"
      ? "Checking..."
      : "جاري الفحص..."
    : TEXT.runAutoRating}
</button>
              </div>
            </div>
          </div>

          {/* SUMMARY CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-white rounded-2xl border shadow-sm p-5">
              <p className="text-sm text-gray-500">{TEXT.requestQueue}</p>
              <div className="mt-2 flex items-end justify-between">
                <h2 className="text-3xl font-bold text-gray-800">
                  {queue.length}
                </h2>
                <span className="text-xs px-3 py-1 rounded-full bg-cyan-50 text-cyan-700 border border-cyan-100">
                  {TEXT.notSent}
                </span>
              </div>
            </div>

            <div className="bg-white rounded-2xl border shadow-sm p-5 opacity-80">
              <p className="text-sm text-gray-500">{TEXT.conversations}</p>
              <div className="mt-2 flex items-end justify-between">
                <h2 className="text-3xl font-bold text-gray-800">{requests.length}</h2>
                <span className="text-xs px-3 py-1 rounded-full bg-gray-50 text-gray-500 border">
                  {TEXT.comingSoon}
                </span>
              </div>
            </div>

            <div className="bg-white rounded-2xl border shadow-sm p-5 opacity-80">
              <p className="text-sm text-gray-500">{TEXT.approvedReviews}</p>
              <div className="mt-2 flex items-end justify-between">
                <h2 className="text-3xl font-bold text-gray-800">
  {productReviews.filter((r) => r.status === "approved").length}
</h2>
<span className="text-xs px-3 py-1 rounded-full bg-orange-50 text-orange-700 border border-orange-100">
  {productReviews.filter((r) => r.status === "pending").length}{" "}
  {lang === "EN" ? "pending" : "قيد الانتظار"}
</span>
              </div>
            </div>
          </div>

          {/* REQUEST QUEUE */}
          <section className="bg-white rounded-2xl border shadow-sm overflow-hidden">
            <div className="p-5 border-b bg-gray-50">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <div>
                  <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                    <FaWhatsapp className="text-green-600" />
                    {TEXT.requestQueue}
                  </h2>
                  <p className="text-sm text-gray-500 mt-1">
                    {TEXT.requestQueueDesc}
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
       <div className="flex flex-col gap-1">
  <span className="text-sm text-gray-500">
    {selectedCount}/{getCurrentSelectionLimit()}{" "}
    {TEXT.selected}
  </span>

  <span
    className={`text-xs font-semibold ${
      reviewDailyUsage.remainingInLast24Hours <= 0
        ? "text-red-600"
        : reviewDailyUsage.remainingInLast24Hours <= 5
        ? "text-orange-600"
        : "text-green-600"
    }`}
  >
    {lang === "EN"
      ? `${reviewDailyUsage.sentInLast24Hours}/${reviewDailyUsage.dailyLimit} new requests sent during the last 24 hours`
      : `تم إرسال ${reviewDailyUsage.sentInLast24Hours}/${reviewDailyUsage.dailyLimit} طلب مراجعة جديد خلال آخر 24 ساعة`}
  </span>
</div>

                  <div className="relative">
                    <FaSearch className="absolute left-3 top-3 text-gray-400" />
                    <input
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder={TEXT.search}
                      className="w-full sm:w-[360px] pl-10 pr-3 py-2.5 border rounded-xl shadow-sm text-sm"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* MOBILE CARDS */}
            <div className="md:hidden p-4 space-y-4">
              {loading ? (
                <div className="text-center py-8 text-gray-500">
                  {TEXT.loading}
                </div>
              ) : filtered.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  {TEXT.empty}
                </div>
              ) : (
               visibleQueue.map((item) => {
                  const isSelected = !!selected[item.orderItemId];

                  return (
                    <div
                      key={item.orderItemId}
                      className={`rounded-2xl border p-4 shadow-sm ${
                        isSelected ? "border-cyan-400 bg-cyan-50" : "bg-white"
                      }`}
                    >
                      <div className="flex gap-3">
                        <button
                          onClick={() => toggleOne(item.orderItemId)}
                          className="text-cyan-700 mt-1"
                        >
                          {isSelected ? <FaCheckSquare /> : <FaRegSquare />}
                        </button>

                        <div className="w-20 h-20 rounded-xl bg-gray-100 overflow-hidden border flex-shrink-0">
                          {item.image ? (
                            <img
                              src={item.image}
                              alt={item.productNameEn}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center text-gray-400">
                              <FaImage />
                            </div>
                          )}
                        </div>

                        <div className="min-w-0 flex-1">
                          <h3 className="font-bold text-gray-800 truncate">
                            {lang === "AR"
                              ? item.productNameAr
                              : item.productNameEn}
                          </h3>
                          <p className="text-xs text-gray-500 mt-1">
                            {item.orderNumber} • {formatDate(item.orderDate)}
                          </p>
                          <p className="text-xs text-gray-500 mt-1">
                            {item.color} / {item.size} • {TEXT.qty}:{" "}
                            {item.quantity}
                          </p>
                          <p className="text-sm font-medium text-gray-700 mt-2">
                            {item.customerName}
                          </p>
                          <p className="text-xs text-gray-500">
                            {item.customerPhone}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* DESKTOP TABLE */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full min-w-[1050px]">
                <thead className="bg-gray-100 text-gray-700 text-sm">
                  <tr>
                    <th className="p-4 text-center w-12">
                      <button
                        onClick={toggleAllFiltered}
                        className="text-cyan-700"
                        title="Select all"
                      >
                        {allFilteredSelected ? <FaCheckSquare /> : <FaRegSquare />}
                      </button>
                    </th>
                    <th className="p-4 text-left">{TEXT.product}</th>
                    <th className="p-4 text-left">{TEXT.customer}</th>
                    <th className="p-4 text-left">{TEXT.order}</th>
                    <th className="p-4 text-left">{TEXT.variant}</th>
                    <th className="p-4 text-left">{TEXT.phone}</th>
                    <th className="p-4 text-center">{TEXT.status}</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="7" className="p-8 text-center text-gray-500">
                        {TEXT.loading}
                      </td>
                    </tr>
                  ) : filtered.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="p-8 text-center text-gray-500">
                        {TEXT.empty}
                      </td>
                    </tr>
                  ) : (
                    visibleQueue.map((item) => {
                      const isSelected = !!selected[item.orderItemId];

                      return (
                        <tr
                          key={item.orderItemId}
                          className={`border-t hover:bg-gray-50 ${
                            isSelected ? "bg-cyan-50" : ""
                          }`}
                        >
                          <td className="p-4 text-center">
                            <button
                              onClick={() => toggleOne(item.orderItemId)}
                              className="text-cyan-700"
                            >
                              {isSelected ? <FaCheckSquare /> : <FaRegSquare />}
                            </button>
                          </td>

                          <td className="p-4">
                            <div className="flex items-center gap-3">
                              <div className="w-14 h-14 rounded-xl bg-gray-100 border overflow-hidden flex-shrink-0">
                                {item.image ? (
                                  <img
                                    src={item.image}
                                    alt={item.productNameEn}
                                    className="w-full h-full object-cover"
                                  />
                                ) : (
                                  <div className="w-full h-full flex items-center justify-center text-gray-400">
                                    <FaImage />
                                  </div>
                                )}
                              </div>
                              <div className="min-w-0">
                                <div className="font-semibold text-gray-800 truncate max-w-[260px]">
                                  {lang === "AR"
                                    ? item.productNameAr
                                    : item.productNameEn}
                                </div>
                                <div className="text-xs text-gray-500">
                                  {item.publicId || `#${item.productId}`}
                                </div>
                              </div>
                            </div>
                          </td>

                          <td className="p-4">
                            <div className="font-medium text-gray-800">
                              {item.customerName}
                            </div>
                            {item.customerEmail && (
                              <div className="text-xs text-gray-500">
                                {item.customerEmail}
                              </div>
                            )}
                          </td>

                          <td className="p-4">
                            <div className="font-semibold text-cyan-700">
                              {item.orderNumber}
                            </div>
                            <div className="text-xs text-gray-500">
                              {formatDate(item.orderDate)}
                            </div>
                          </td>

                          <td className="p-4 text-sm text-gray-700">
                            {item.color} / {item.size}
                            <div className="text-xs text-gray-500">
                              {TEXT.qty}: {item.quantity}
                            </div>
                          </td>

                          <td className="p-4 text-sm text-gray-700">
                            {item.customerPhone}
                          </td>

                          <td className="p-4 text-center">
                            <span className="inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-orange-50 text-orange-700 border border-orange-100">
                              {TEXT.notSent}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
                        </div>

            {filtered.length > 6 && (
              <div className="p-4 border-t bg-white flex justify-center">
                <button
                  type="button"
                  onClick={() => setQueueExpanded((v) => !v)}
                  className="px-5 py-2 rounded-xl text-sm font-semibold bg-cyan-50 text-cyan-700 hover:bg-cyan-100 transition"
                >
                  {queueExpanded ? TEXT.showLess : TEXT.showMore}
                </button>
              </div>
            )}
          </section>

<section className="bg-white rounded-2xl border shadow-sm overflow-hidden mt-6">
  <div className="p-5 border-b bg-gray-50">
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <FaStar className="text-yellow-500" />
          {TEXT.conversations}
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          {TEXT.conversationsDesc}
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
        <label className="text-sm text-gray-500 font-medium">
          {TEXT.filter}
        </label>

        <select
          value={requestStatusFilter}
          onChange={(e) => {
            setRequestStatusFilter(e.target.value);
            setRequestsExpanded(false);
          }}
          className="border rounded-xl px-3 py-2 text-sm bg-white shadow-sm min-w-[220px]"
        >
          <option value="all">{TEXT.all}</option>
          <option value="sent">{TEXT.sentFilter}</option>
          <option value="completed">{TEXT.completedFilter}</option>
          <option value="rating_requested">{TEXT.waitingForRatingFilter}</option>
          <option value="needs_admin_attention">
            {TEXT.needsAdminAttentionFilter}
          </option>
        </select>
      </div>
    </div>
  </div>

  {/* MOBILE CARDS */}
  <div className="md:hidden p-4 space-y-4">
    {requestsLoading ? (
      <div className="text-center py-8 text-gray-500">
        {TEXT.loading}
      </div>
    ) : filteredRequests.length === 0 ? (
      <div className="text-center py-8 text-gray-500">
        {lang === "EN"
          ? "No review requests created yet."
          : "لم يتم إنشاء طلبات مراجعة بعد."}
      </div>
    ) : (
      visibleRequests.map((item) => (
        <div
          key={item.id}
          className="rounded-2xl border p-4 shadow-sm bg-white"
        >
          <div className="flex gap-3">
            <div className="w-20 h-20 rounded-xl bg-gray-100 overflow-hidden border flex-shrink-0">
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.productNameEn}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400">
                  <FaImage />
                </div>
              )}
            </div>

            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-bold text-gray-800 truncate">
                  {lang === "AR" ? item.productNameAr : item.productNameEn}
                </h3>
                <span
  className={`text-[11px] px-2 py-1 rounded-full border font-semibold ${statusBadge(
    getRequestDisplayStatus(item)
  )}`}
>
  {getRequestStatusLabel(item)}
</span>
              </div>

              <p className="text-xs text-gray-500 mt-1">
                {item.orderNumber} • {formatDate(item.createdAt)}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {item.color} / {item.size} • {TEXT.qty}: {item.quantity}
              </p>
              <p className="text-sm font-medium text-gray-700 mt-2">
                {item.customerName}
              </p>
              <p className="text-xs text-gray-500">
                {item.customerPhone} • {item.language}
              </p>
<div className="mt-3 flex flex-wrap gap-2">
  <button
    onClick={() => openConversation(item.id)}
    className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-cyan-700 bg-cyan-50 hover:bg-cyan-100 transition"
  >
    <FaEye />
    {TEXT.viewConversation}
  </button>

{canResendRequest(item) && (
  <button
    onClick={() => handleResendRequest(item.id)}
    disabled={resendingRequestId === item.id}
    className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition disabled:opacity-60"
    title={TEXT.resendAfter24h}
  >
    <FaPaperPlane />
    {resendingRequestId === item.id ? TEXT.resending : TEXT.resend}
  </button>
)}

  {canDeleteRequest(item.status) && (
    <button
      onClick={() => setDeleteRequestId(item.id)}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-red-600 bg-red-50 hover:bg-red-100 transition"
    >
      <FaTrash />
      {TEXT.delete}
    </button>
  )}
</div>
            </div>
          </div>
        </div>
      ))
    )}
  </div>

  {/* DESKTOP TABLE */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full min-w-[1050px]">
      <thead className="bg-gray-100 text-gray-700 text-sm">
        <tr>
          <th className="p-4 text-left">{TEXT.product}</th>
          <th className="p-4 text-left">{TEXT.customer}</th>
          <th className="p-4 text-left">{TEXT.order}</th>
          <th className="p-4 text-left">{TEXT.variant}</th>
          <th className="p-4 text-left">{TEXT.language}</th>
          <th className="p-4 text-center">{TEXT.status}</th>
<th className="p-4 text-center">{TEXT.actions}</th>
        </tr>
      </thead>

      <tbody>
        {requestsLoading ? (
          <tr>
            <td colSpan="7" className="p-8 text-center text-gray-500">
              {TEXT.loading}
            </td>
          </tr>
        ) : filteredRequests.length === 0 ? (
          <tr>
            <td colSpan="7" className="p-8 text-center text-gray-500">
              {lang === "EN"
                ? "No review requests created yet."
                : "لم يتم إنشاء طلبات مراجعة بعد."}
            </td>
          </tr>
        ) : (
          visibleRequests.map((item) => (
            <tr key={item.id} className="border-t hover:bg-gray-50">
              <td className="p-4">
                <div className="flex items-center gap-3">
                  <div className="w-14 h-14 rounded-xl bg-gray-100 border overflow-hidden flex-shrink-0">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.productNameEn}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400">
                        <FaImage />
                      </div>
                    )}
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-800 truncate max-w-[260px]">
                      {lang === "AR"
                        ? item.productNameAr
                        : item.productNameEn}
                    </div>
                    <div className="text-xs text-gray-500">
                      {item.publicId || `#${item.productId}`}
                    </div>
                  </div>
                </div>
              </td>

              <td className="p-4">
                <div className="font-medium text-gray-800">
                  {item.customerName}
                </div>
                <div className="text-xs text-gray-500">
                  {item.customerPhone}
                </div>
              </td>

              <td className="p-4">
                <div className="font-semibold text-cyan-700">
                  {item.orderNumber}
                </div>
                <div className="text-xs text-gray-500">
                  {formatDate(item.createdAt)}
                </div>
              </td>

              <td className="p-4 text-sm text-gray-700">
                {item.color} / {item.size}
                <div className="text-xs text-gray-500">
                  {TEXT.qty}: {item.quantity}
                </div>
              </td>

              <td className="p-4 text-sm font-semibold text-gray-700">
                {item.language}
              </td>

              <td className="p-4 text-center">
                <span
  className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold border ${statusBadge(
    getRequestDisplayStatus(item)
  )}`}
>
  {getRequestStatusLabel(item)}
</span>
              </td>
<td className="p-4 text-center">
  <div className="flex items-center justify-center gap-2">
    <button
      onClick={() => openConversation(item.id)}
      className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-cyan-600 hover:bg-cyan-50 transition"
      title={TEXT.viewConversation}
    >
      <FaEye />
    </button>

{canResendRequest(item) && (
  <button
    onClick={() => handleResendRequest(item.id)}
    disabled={resendingRequestId === item.id}
    className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-indigo-600 hover:bg-indigo-50 transition disabled:opacity-60"
    title={TEXT.resendAfter24h}
  >
    <FaPaperPlane />
  </button>
)}

    {canDeleteRequest(item.status) ? (
      <button
        onClick={() => setDeleteRequestId(item.id)}
        className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-red-600 hover:bg-red-50 transition"
        title={TEXT.delete}
      >
        <FaTrash />
      </button>
    ) : (
      <span className="text-xs text-gray-400">—</span>
    )}
  </div>
</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
    </div>

  {filteredRequests.length > 6 && (
    <div className="p-4 border-t bg-white flex justify-center">
      <button
        type="button"
        onClick={() => setRequestsExpanded((v) => !v)}
        className="px-5 py-2 rounded-xl text-sm font-semibold bg-cyan-50 text-cyan-700 hover:bg-cyan-100 transition"
      >
        {requestsExpanded ? TEXT.showLess : TEXT.showMore}
      </button>
    </div>
  )}
</section>

<section className="bg-white rounded-2xl border shadow-sm overflow-hidden mt-6">
  <div className="p-5 border-b bg-gray-50">
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
          <FaStar className="text-yellow-500" />
          {TEXT.pendingReviews}
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          {TEXT.pendingReviewsDesc}
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
        <label className="text-sm text-gray-500 font-medium">
          {TEXT.filter}
        </label>

        <select
          value={productReviewStatusFilter}
          onChange={(e) => {
            setProductReviewStatusFilter(e.target.value);
            setProductReviewsExpanded(false);
          }}
          className="border rounded-xl px-3 py-2 text-sm bg-white shadow-sm min-w-[180px]"
        >
          <option value="all">{TEXT.all}</option>
          <option value="pending">{TEXT.pending}</option>
          <option value="approved">{TEXT.approved}</option>
          <option value="rejected">{TEXT.rejected}</option>
        </select>
      </div>
    </div>
  </div>

  {/* MOBILE CARDS */}
  <div className="md:hidden p-4 space-y-4">
    {productReviewsLoading ? (
      <div className="text-center py-8 text-gray-500">
        {TEXT.loading}
      </div>
    ) : filteredProductReviews.length === 0 ? (
      <div className="text-center py-8 text-gray-500">
        {lang === "EN"
          ? "No product reviews yet."
          : "لا توجد مراجعات منتجات بعد."}
      </div>
    ) : (
      visibleProductReviews.map((review) => (
        <div
          key={review.id}
          className="rounded-2xl border p-4 shadow-sm bg-white"
        >
          <div className="flex gap-3">
            <div className="w-20 h-20 rounded-xl bg-gray-100 overflow-hidden border flex-shrink-0">
              {review.image ? (
                <img
                  src={review.image}
                  alt={review.productNameEn}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400">
                  <FaImage />
                </div>
              )}
            </div>

            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-bold text-gray-800 truncate">
                  {lang === "AR" ? review.productNameAr : review.productNameEn}
                </h3>
                <span
                  className={`text-[11px] px-2 py-1 rounded-full border font-semibold ${productReviewStatusBadge(
                    review.status
                  )}`}
                >
                  {productReviewStatusLabel(review.status)}
                </span>
              </div>

              <p className="text-xs text-gray-500 mt-1">
                {review.orderNumber} • {formatDate(review.createdAt)}
              </p>

              <p className="text-sm text-yellow-500 mt-2">
                {"★".repeat(review.rating)}
                <span className="text-gray-300">
                  {"★".repeat(5 - review.rating)}
                </span>
              </p>

              {review.reviewText ? (
  <p className="text-sm text-gray-700 mt-2 whitespace-pre-line">
    {review.reviewText}
  </p>
) : (
  <p className="text-sm text-gray-400 mt-2">—</p>
)}

{renderReviewMedia(review, "mobile")}

              <p className="text-xs text-gray-500 mt-2">
                {review.customerName} • {review.customerPhone}
              </p>

              <div className="mt-3 flex flex-wrap gap-2">
                <button
                  onClick={() =>
                    handleUpdateProductReviewStatus(review.id, "approved")
                  }
                  disabled={updatingReviewId === review.id}
                  className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-green-700 bg-green-50 hover:bg-green-100 transition disabled:opacity-60"
                >
                  <FaCheck />
                  {TEXT.approve}
                </button>

                <button
                  onClick={() =>
                    handleUpdateProductReviewStatus(review.id, "rejected")
                  }
                  disabled={updatingReviewId === review.id}
                  className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-red-600 bg-red-50 hover:bg-red-100 transition disabled:opacity-60"
                >
                  <FaTimes />
                  {TEXT.reject}
                </button>
              </div>
            </div>
          </div>
        </div>
      ))
    )}
  </div>

  {/* DESKTOP TABLE */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full min-w-[1100px]">
      <thead className="bg-gray-100 text-gray-700 text-sm">
        <tr>
          <th className="p-4 text-left">{TEXT.product}</th>
          <th className="p-4 text-left">{TEXT.customer}</th>
          <th className="p-4 text-left">{TEXT.order}</th>
          <th className="p-4 text-center">Rating</th>
          <th className="p-4 text-left">{TEXT.reviewText}</th>
          <th className="p-4 text-center">{TEXT.status}</th>
          <th className="p-4 text-center">{TEXT.actions}</th>
        </tr>
      </thead>

      <tbody>
        {productReviewsLoading ? (
          <tr>
            <td colSpan="7" className="p-8 text-center text-gray-500">
              {TEXT.loading}
            </td>
          </tr>
        ) : filteredProductReviews.length === 0 ? (
          <tr>
            <td colSpan="7" className="p-8 text-center text-gray-500">
              {lang === "EN"
                ? "No product reviews yet."
                : "لا توجد مراجعات منتجات بعد."}
            </td>
          </tr>
        ) : (
          visibleProductReviews.map((review) => (
            <tr key={review.id} className="border-t hover:bg-gray-50">
              <td className="p-4">
                <div className="flex items-center gap-3">
                  <div className="w-14 h-14 rounded-xl bg-gray-100 border overflow-hidden flex-shrink-0">
                    {review.image ? (
                      <img
                        src={review.image}
                        alt={review.productNameEn}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400">
                        <FaImage />
                      </div>
                    )}
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-800 truncate max-w-[240px]">
                      {lang === "AR"
                        ? review.productNameAr
                        : review.productNameEn}
                    </div>
                    <div className="text-xs text-gray-500">
                      {review.publicId || `#${review.productId}`}
                    </div>
                  </div>
                </div>
              </td>

              <td className="p-4">
                <div className="font-medium text-gray-800">
                  {review.customerName}
                </div>
                <div className="text-xs text-gray-500">
                  {review.customerPhone}
                </div>
              </td>

              <td className="p-4">
                <div className="font-semibold text-cyan-700">
                  {review.orderNumber}
                </div>
                <div className="text-xs text-gray-500">
                  {formatDate(review.createdAt)}
                </div>
              </td>

              <td className="p-4 text-center">
                <span className="text-yellow-500 text-sm">
                  {"★".repeat(review.rating)}
                  <span className="text-gray-300">
                    {"★".repeat(5 - review.rating)}
                  </span>
                </span>
              </td>

     <td className="p-4 max-w-[320px]">
  {review.reviewText ? (
    <button
      type="button"
      onClick={() =>
        setReviewTextPreview({
          id: review.id,
          text: review.reviewText,
          customerName: review.customerName,
          productName:
            lang === "AR"
              ? review.productNameAr || review.productNameEn
              : review.productNameEn || review.productNameAr,
        })
      }
      className={`block w-full cursor-pointer rounded-xl p-2 transition hover:bg-cyan-50/60 focus:outline-none focus:ring-2 focus:ring-cyan-300 ${
        lang === "AR" ? "text-right" : "text-left"
      }`}
      title={TEXT.hoverToRead}
    >
      <p className="text-sm text-gray-700 line-clamp-2 whitespace-pre-line">
        {review.reviewText}
      </p>

      {review.reviewText.length > 90 && (
        <span className="mt-1 inline-block text-[11px] font-semibold text-cyan-700">
          {lang === "EN" ? "Click to read more" : "اضغط لقراءة المزيد"}
        </span>
      )}
    </button>
  ) : (
    <p className="text-sm text-gray-400">—</p>
  )}

  {renderReviewMedia(review, "table")}
</td>

              <td className="p-4 text-center">
                <span
                  className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold border ${productReviewStatusBadge(
                    review.status
                  )}`}
                >
                  {productReviewStatusLabel(review.status)}
                </span>
              </td>

              <td className="p-4 text-center">
                <div className="flex items-center justify-center gap-2">
                  <button
                    onClick={() =>
                      handleUpdateProductReviewStatus(review.id, "approved")
                    }
                    disabled={updatingReviewId === review.id}
                    className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-green-700 hover:bg-green-50 transition disabled:opacity-60"
                    title={TEXT.approve}
                  >
                    <FaCheck />
                  </button>

                  <button
                    onClick={() =>
                      handleUpdateProductReviewStatus(review.id, "rejected")
                    }
                    disabled={updatingReviewId === review.id}
                    className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-red-600 hover:bg-red-50 transition disabled:opacity-60"
                    title={TEXT.reject}
                  >
                    <FaTimes />
                  </button>
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
    </div>

  {filteredProductReviews.length > 6 && (
    <div className="p-4 border-t bg-white flex justify-center">
      <button
        type="button"
        onClick={() => setProductReviewsExpanded((v) => !v)}
        className="px-5 py-2 rounded-xl text-sm font-semibold bg-cyan-50 text-cyan-700 hover:bg-cyan-100 transition"
      >
        {productReviewsExpanded ? TEXT.showLess : TEXT.showMore}
      </button>
    </div>
  )}
</section>

{conversationModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9997] p-3 sm:p-5">
    <div className="bg-white rounded-3xl shadow-2xl w-full max-w-6xl max-h-[92vh] overflow-hidden flex flex-col">
      {/* HEADER */}
      <div className="px-5 py-4 border-b bg-gray-50 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-lg font-bold text-gray-800">
              {TEXT.conversationTitle}
            </h2>

            {activeConversation?.needsAdminAttention && (
              <span className="inline-flex px-3 py-1 rounded-full text-[11px] font-semibold bg-red-50 text-red-700 border border-red-100">
                {TEXT.needsAdminAttentionFilter}
              </span>
            )}

            {activeConversation?.requestStatus &&
  !activeConversation?.needsAdminAttention && (
    <span
      className={`inline-flex px-3 py-1 rounded-full text-[11px] font-semibold border ${statusBadge(
        activeConversation.requestStatus
      )}`}
    >
      {activeConversation.requestStatus === "rating_requested"
        ? TEXT.waitingForRatingFilter
        : activeConversation.requestStatus === "completed"
        ? TEXT.completedFilter
        : ["sent", "delivered"].includes(
            activeConversation.requestStatus
          )
        ? TEXT.sentFilter
        : activeConversation.requestStatus}
    </span>
  )}
          </div>

          {activeConversation && (
            <div className="text-sm text-gray-500 mt-1 truncate">
              {activeConversation.customerName} •{" "}
              {activeConversation.customerPhone} •{" "}
              {activeConversation.orderNumber}
            </div>
          )}

          {activeConversation && (
            <div className="text-xs text-gray-400 mt-1">
              {TEXT.step}: {activeConversation.currentStep} •{" "}
              {activeConversation.language}
            </div>
          )}
        </div>

        <button
          onClick={() => setConversationModal(false)}
          className="w-10 h-10 rounded-2xl bg-white border hover:bg-gray-100 transition text-gray-600 flex items-center justify-center flex-shrink-0"
        >
          ✕
        </button>
      </div>

      <div className="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_390px]">
        {/* LEFT SIDE */}
        <div className="min-h-0 flex flex-col bg-gray-100">
          {/* PRODUCT */}
          {activeConversation && (
            <div className="p-4 border-b bg-white flex items-center gap-3">
              <div className="w-16 h-16 rounded-2xl bg-gray-100 border overflow-hidden flex-shrink-0">
                {activeConversation.image ? (
                  <img
                    src={activeConversation.image}
                    alt={activeConversation.productNameEn}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-400">
                    <FaImage />
                  </div>
                )}
              </div>

              <div className="min-w-0 flex-1">
                <div className="font-bold text-gray-800 truncate">
                  {lang === "AR"
                    ? activeConversation.productNameAr
                    : activeConversation.productNameEn}
                </div>

                <div className="text-xs text-gray-500 mt-1">
                  {activeConversation.color} / {activeConversation.size} •{" "}
                  {TEXT.qty}: {activeConversation.quantity}
                </div>

                <div className="text-xs text-gray-400 mt-1">
                  {activeConversation.publicId || `#${activeConversation.productId}`}
                </div>
              </div>
            </div>
          )}

          {/* MESSAGES */}
          <div className="flex-1 min-h-0 overflow-y-auto p-4 space-y-3">
            {conversationLoading ? (
              <div className="text-center py-10 text-gray-500">
                {TEXT.conversationLoading}
              </div>
            ) : conversationMessages.length === 0 ? (
              <div className="text-center py-10 text-gray-500">
                {TEXT.noMessages}
              </div>
            ) : (
              conversationMessages.map((msg) => {
                const isOutbound = msg.direction === "outbound";

                return (
                  <div
                    key={msg.id}
                    className={`flex ${isOutbound ? "justify-end" : "justify-start"}`}
                  >
                    <div
                      className={`
                        max-w-[88%] rounded-2xl px-4 py-3 shadow-sm border
                        ${
                          isOutbound
                            ? "bg-green-50 border-green-100 text-gray-800"
                            : msg.isNormal === false
                            ? "bg-red-50 border-red-100 text-gray-800"
                            : "bg-white border-gray-200 text-gray-800"
                        }
                      `}
                    >
                      <div className="flex items-center justify-between gap-3 mb-1">
                        <div className="text-xs font-semibold text-gray-500">
                          {messageSenderLabel(msg)}
                        </div>

                        <div className="text-[10px] text-gray-400">
                          #{msg.id}
                        </div>
                      </div>

                      {msg.messageType === "text" || msg.messageType === "system" ? (
                        <p className="text-sm whitespace-pre-line leading-relaxed">
                          {msg.body}
                        </p>
                      ) : msg.messageType === "rating" ? (
                        <div className="text-sm font-bold text-yellow-600">
                          ⭐ {msg.rating}/5
                        </div>
                      ) : msg.mediaUrl && msg.messageType === "image" ? (
                        <div className="text-sm">
                          <button
                            type="button"
                            onClick={() =>
                              setMediaPreview({
                                url: msg.mediaUrl,
                                type: msg.messageType,
                                mime: msg.mediaMimeType,
                                title: msg.mediaFilename || "Review media",
                              })
                            }
                            className="block"
                          >
                            <img
                              src={msg.mediaUrl}
                              alt="Customer review"
                              className="max-h-72 rounded-xl border object-contain bg-white"
                            />
                          </button>

                          {msg.body && (
                            <p className="text-sm whitespace-pre-line leading-relaxed mt-2">
                              {msg.body}
                            </p>
                          )}
                        </div>
                      ) : msg.mediaUrl && msg.messageType === "video" ? (
                        <div className="text-sm">
                          <video
                            controls
                            playsInline
                            preload="metadata"
                            className="max-h-72 rounded-xl border bg-black"
                          >
                            <source
                              src={msg.mediaUrl}
                              type={msg.mediaMimeType || "video/mp4"}
                            />
                          </video>

                          {msg.body && (
                            <p className="text-sm whitespace-pre-line leading-relaxed mt-2">
                              {msg.body}
                            </p>
                          )}
                        </div>
                      ) : msg.mediaUrl && msg.messageType === "audio" ? (
                        <div className="text-sm">
                          <div className="rounded-xl border bg-white p-2">
                            <audio controls className="w-full">
                              <source
                                src={msg.mediaUrl}
                                type={msg.mediaMimeType || "audio/ogg"}
                              />
                            </audio>
                          </div>

                          {msg.body && (
                            <p className="text-sm whitespace-pre-line leading-relaxed mt-2">
                              {msg.body}
                            </p>
                          )}
                        </div>
                      ) : msg.mediaUrl ? (
                        <a
                          href={msg.mediaUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="text-cyan-700 underline text-sm"
                        >
                          {msg.mediaFilename || msg.messageType}
                        </a>
                      ) : (
                        <p className="text-sm text-gray-500">
                          {msg.messageType}
                        </p>
                      )}

                      <div className="flex items-center justify-between gap-3 mt-3">
                        <div className="text-[11px] text-gray-400">
                          {formatDateTime(msg.createdAt)}
                        </div>

                        {msg.isNormal === false && (
                          <span className="text-[10px] px-2 py-0.5 rounded-full bg-red-100 text-red-700 border border-red-200 font-semibold">
                            {TEXT.unexpectedResponse}
                          </span>
                        )}
                      </div>

                      {activeConversation?.needsAdminAttention &&
                        msg.direction === "inbound" &&
                        msg.senderType === "customer" && (
                          <div className="mt-3 flex flex-wrap gap-2">
                            {msg.messageType === "text" &&
                              String(msg.body || "").trim() && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedReviewMessageId(String(msg.id));
                                    setManualReviewText(msg.body || "");
                                  }}
                                  className={`px-2.5 py-1 rounded-lg text-[11px] font-semibold border transition ${
                                    String(selectedReviewMessageId) === String(msg.id)
                                      ? "bg-cyan-600 text-white border-cyan-600"
                                      : "bg-cyan-50 text-cyan-700 border-cyan-100 hover:bg-cyan-100"
                                  }`}
                                >
                                  {TEXT.useMessage}
                                </button>
                              )}

                            {(msg.messageType === "rating" || msg.rating) && (
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedRatingMessageId(String(msg.id));
                                  setManualRating(String(msg.rating || ""));
                                }}
                                className={`px-2.5 py-1 rounded-lg text-[11px] font-semibold border transition ${
                                  String(selectedRatingMessageId) === String(msg.id)
                                    ? "bg-yellow-500 text-white border-yellow-500"
                                    : "bg-yellow-50 text-yellow-700 border-yellow-100 hover:bg-yellow-100"
                                }`}
                              >
                                {TEXT.useRating}
                              </button>
                            )}

                            {["image", "audio", "video"].includes(msg.messageType) &&
                              msg.mediaUrl && (
                                <button
                                  type="button"
                                  onClick={() => toggleSelectedMediaMessage(msg.id)}
                                  className={`px-2.5 py-1 rounded-lg text-[11px] font-semibold border transition ${
                                    selectedMediaMessageIds.includes(Number(msg.id))
                                      ? "bg-purple-600 text-white border-purple-600"
                                      : "bg-purple-50 text-purple-700 border-purple-100 hover:bg-purple-100"
                                  }`}
                                >
                                  {TEXT.useMedia}
                                </button>
                              )}
                          </div>
                        )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <aside className="min-h-0 overflow-y-auto border-t lg:border-t-0 lg:border-l bg-white">
          <div className="p-4 space-y-4">
            {/* MANUAL RESOLVE */}
            {activeConversation && activeConversation.needsAdminAttention && (
              <div className="rounded-2xl bg-red-50 border border-red-100 p-4">
                <div className="mb-4">
                  <h3 className="text-sm font-bold text-red-700">
                    {TEXT.manualResolve}
                  </h3>
                  <p className="text-xs text-red-700/70 mt-1 leading-relaxed">
                    {TEXT.manualResolveDesc}
                  </p>
                </div>

                <div className="space-y-3">
                  <div>
                    <label className="text-xs font-semibold text-gray-600">
                      {TEXT.selectReviewMessage}
                    </label>

                    <select
                      value={selectedReviewMessageId}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedReviewMessageId(value);

                        const selectedMsg = customerTextMessages.find(
                          (msg) => String(msg.id) === String(value)
                        );

                        if (selectedMsg?.body) {
                          setManualReviewText(selectedMsg.body);
                        }
                      }}
                      className="mt-1 w-full border rounded-xl px-3 py-2 text-sm bg-white"
                    >
                      <option value="">{TEXT.chooseOption}</option>
                      {customerTextMessages.map((msg) => (
                        <option key={msg.id} value={msg.id}>
                          #{msg.id} — {String(msg.body || "").slice(0, 55)}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="text-xs font-semibold text-gray-600">
                      {TEXT.selectRatingMessage}
                    </label>

                    <select
                      value={selectedRatingMessageId}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedRatingMessageId(value);

                        const selectedMsg = customerRatingMessages.find(
                          (msg) => String(msg.id) === String(value)
                        );

                        if (selectedMsg?.rating) {
                          setManualRating(String(selectedMsg.rating));
                        }
                      }}
                      className="mt-1 w-full border rounded-xl px-3 py-2 text-sm bg-white"
                    >
                      <option value="">{TEXT.chooseOption}</option>
                      {customerRatingMessages.map((msg) => (
                        <option key={msg.id} value={msg.id}>
                          #{msg.id} — ⭐ {msg.rating || ""}/5
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="text-xs font-semibold text-gray-600">
                      {TEXT.manualRating}
                    </label>

                    <select
                      value={manualRating}
                      onChange={(e) => setManualRating(e.target.value)}
                      className="mt-1 w-full border rounded-xl px-3 py-2 text-sm bg-white"
                    >
                      <option value="">{TEXT.chooseOption}</option>
                      <option value="5">5 ⭐⭐⭐⭐⭐</option>
                      <option value="4">4 ⭐⭐⭐⭐</option>
                      <option value="3">3 ⭐⭐⭐</option>
                      <option value="2">2 ⭐⭐</option>
                      <option value="1">1 ⭐</option>
                    </select>
                  </div>

                  <div>
                    <label className="text-xs font-semibold text-gray-600">
                      {TEXT.reviewPreset}
                    </label>

                    <select
                      value={reviewPreset}
                      onChange={(e) => {
                        setReviewPreset(e.target.value);

                        if (e.target.value) {
                          setManualReviewText(e.target.value);
                        }
                      }}
                      className="mt-1 w-full border rounded-xl px-3 py-2 text-sm bg-white"
                    >
                      <option value="">{TEXT.chooseOption}</option>
                      {manualResolveOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>

                  {customerMediaMessages.length > 0 && (
                    <div>
                      <label className="text-xs font-semibold text-gray-600">
                        {TEXT.selectMediaMessages}
                      </label>

                      <div className="mt-2 grid grid-cols-3 gap-2">
                        {customerMediaMessages.map((msg) => {
                          const selectedMedia = selectedMediaMessageIds.includes(
                            Number(msg.id)
                          );

                          return (
                            <button
                              key={msg.id}
                              type="button"
                              onClick={() => toggleSelectedMediaMessage(msg.id)}
                              className={`rounded-xl border p-1.5 text-left transition ${
                                selectedMedia
                                  ? "border-purple-500 bg-purple-50"
                                  : "border-gray-200 bg-white hover:bg-gray-50"
                              }`}
                            >
                              <div className="text-[10px] font-semibold text-gray-500 mb-1 truncate">
                                #{msg.id}
                              </div>

                              {msg.messageType === "image" ? (
                                <img
                                  src={msg.mediaUrl}
                                  alt="Review media"
                                  className="w-full h-14 object-cover rounded-lg border bg-white"
                                />
                              ) : (
                                <div className="w-full h-14 rounded-lg border bg-gray-100 text-gray-600 flex items-center justify-center text-[10px]">
                                  {msg.messageType}
                                </div>
                              )}

                              {selectedMedia && (
                                <div className="text-[10px] font-bold text-purple-700 mt-1">
                                  Selected
                                </div>
                              )}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  <div>
                    <label className="text-xs font-semibold text-gray-600">
                      {TEXT.manualReviewText}
                    </label>

                    <textarea
                      value={manualReviewText}
                      onChange={(e) => setManualReviewText(e.target.value)}
                      rows={4}
                      className="mt-1 w-full border rounded-2xl px-4 py-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-300"
                      placeholder={TEXT.manualReviewText}
                    />
                  </div>

                  <button
                    type="button"
                    onClick={handleManualResolve}
                    disabled={manualResolveSaving}
                    className={`
                      w-full inline-flex items-center justify-center gap-2
                      px-5 py-3 rounded-2xl text-sm font-semibold transition
                      ${
                        manualResolveSaving
                          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                          : "bg-red-600 text-white hover:bg-red-700 shadow"
                      }
                    `}
                  >
                    <FaCheck />
                    {manualResolveSaving
                      ? lang === "EN"
                        ? "Saving..."
                        : "جاري الحفظ..."
                      : TEXT.saveAsPendingReview}
                  </button>
                </div>
              </div>
            )}

            {/* ADMIN REPLY */}
            <div className="rounded-2xl border bg-gray-50 p-4">
              <h3 className="text-sm font-bold text-gray-800 mb-3">
                {TEXT.adminLabel}
              </h3>

              <textarea
                value={adminReply}
                onChange={(e) => setAdminReply(e.target.value)}
                placeholder={TEXT.replyPlaceholder}
                rows={4}
                className="w-full border rounded-2xl px-4 py-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-cyan-400 bg-white"
              />

              <button
                onClick={handleSendAdminReply}
                disabled={sendingReply || !adminReply.trim()}
                className={`
                  mt-3 w-full px-5 py-3 rounded-2xl text-sm font-semibold transition
                  inline-flex items-center justify-center gap-2
                  ${
                    sendingReply || !adminReply.trim()
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : "bg-cyan-600 text-white hover:bg-cyan-700 shadow"
                  }
                `}
              >
                <FaPaperPlane />
                {sendingReply
                  ? lang === "EN"
                    ? "Sending..."
                    : "جاري الإرسال..."
                  : TEXT.sendReply}
              </button>

              <p className="text-xs text-gray-400 mt-2">
                {lang === "EN"
                  ? "This reply will be sent to the customer through WhatsApp."
                  : "سيتم إرسال هذا الرد إلى العميل عبر واتساب."}
              </p>
            </div>

            {/* TEST TOOLS */}
            {showReviewTestingTools && (
              <div className="rounded-2xl border border-yellow-100 bg-yellow-50 p-4 space-y-4">
                <div>
                  <div className="text-xs font-bold text-yellow-700 mb-2">
                    {TEXT.simulateCustomerReply}
                  </div>

                  <textarea
                    value={customerSimulation}
                    onChange={(e) => setCustomerSimulation(e.target.value)}
                    placeholder={TEXT.customerReplyPlaceholder}
                    rows={3}
                    className="w-full border rounded-2xl px-4 py-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-yellow-400 bg-white"
                  />

                  <button
                    onClick={handleSimulateCustomerReply}
                    disabled={sendingCustomerSimulation || !customerSimulation.trim()}
                    className={`
                      mt-2 w-full px-4 py-2.5 rounded-2xl text-sm font-semibold transition
                      inline-flex items-center justify-center gap-2
                      ${
                        sendingCustomerSimulation || !customerSimulation.trim()
                          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                          : "bg-yellow-500 text-white hover:bg-yellow-600 shadow"
                      }
                    `}
                  >
                    <FaPaperPlane />
                    {sendingCustomerSimulation
                      ? lang === "EN"
                        ? "Saving..."
                        : "جاري الحفظ..."
                      : TEXT.simulateCustomerReply}
                  </button>
                </div>

                <div className="border-t border-yellow-100 pt-4">
                  <div className="text-xs font-bold text-indigo-700 mb-2">
                    {TEXT.simulateRatingReply}
                  </div>

                  <input
                    value={ratingSimulation}
                    onChange={(e) => setRatingSimulation(e.target.value)}
                    placeholder={TEXT.ratingReplyPlaceholder}
                    className="w-full border rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 bg-white"
                  />

                  <button
                    onClick={handleSimulateRatingReply}
                    disabled={sendingRatingSimulation || !ratingSimulation.trim()}
                    className={`
                      mt-2 w-full px-4 py-2.5 rounded-2xl text-sm font-semibold transition
                      inline-flex items-center justify-center gap-2
                      ${
                        sendingRatingSimulation || !ratingSimulation.trim()
                          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                          : "bg-indigo-600 text-white hover:bg-indigo-700 shadow"
                      }
                    `}
                  >
                    <FaPaperPlane />
                    {sendingRatingSimulation
                      ? lang === "EN"
                        ? "Saving..."
                        : "جاري الحفظ..."
                      : TEXT.simulateRatingReply}
                  </button>
                </div>

                <p className="text-xs text-yellow-700/70">
                  {lang === "EN"
                    ? "Testing only. Real replies come from WhatsApp webhook."
                    : "للتجربة فقط. الردود الحقيقية تصل من Webhook واتساب."}
                </p>
              </div>
            )}
          </div>
        </aside>
      </div>
    </div>
  </div>
)}

{reviewTextPreview && (
  <div
  className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/35 p-4"
  onClick={() => setReviewTextPreview(null)}
>
    <div
      className="w-full max-w-xl overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-2xl"
      dir={lang === "AR" ? "rtl" : "ltr"}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-start justify-between gap-4 border-b bg-gray-50 px-5 py-4">
        <div className="min-w-0">
          <h2 className="font-bold text-gray-800">
            {TEXT.fullReview}
          </h2>

          {reviewTextPreview.customerName && (
            <p className="mt-1 text-sm text-gray-500">
              {reviewTextPreview.customerName}
            </p>
          )}

          {reviewTextPreview.productName && (
            <p className="mt-1 truncate text-xs text-gray-400">
              {reviewTextPreview.productName}
            </p>
          )}
        </div>

        <button
          type="button"
          onClick={() => setReviewTextPreview(null)}
          className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl border bg-white text-gray-600 transition hover:bg-gray-100"
          aria-label={TEXT.closePreview}
          title={TEXT.closePreview}
        >
          ✕
        </button>
      </div>

      <div className="max-h-[65vh] overflow-y-auto p-5">
        <p className="whitespace-pre-wrap break-words text-sm leading-7 text-gray-700">
          {reviewTextPreview.text}
        </p>
      </div>
    </div>
  </div>
)}

{mediaPreview && (
  <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[10000] p-4">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-5xl max-h-[92vh] overflow-hidden flex flex-col">
      <div className="p-4 border-b flex items-center justify-between gap-3">
        <div className="min-w-0">
          <h2 className="font-bold text-gray-800 truncate">
            {mediaPreview.title || "Review media"}
          </h2>
          <p className="text-xs text-gray-500 mt-1">
            {mediaPreview.type}
          </p>
        </div>

        <button
          onClick={() => setMediaPreview(null)}
          className="w-9 h-9 rounded-xl bg-gray-100 hover:bg-gray-200 transition"
        >
          ✕
        </button>
      </div>

      <div className="p-4 bg-gray-100 flex-1 overflow-auto flex items-center justify-center">
        {mediaPreview.type === "image" && (
          <img
            src={mediaPreview.url}
            alt="Review media"
            className="max-w-full max-h-[75vh] object-contain rounded-xl bg-white"
          />
        )}

        {mediaPreview.type === "video" && (
          <video
            controls
            playsInline
            autoPlay
            className="max-w-full max-h-[75vh] rounded-xl bg-black"
          >
            <source src={mediaPreview.url} type={mediaPreview.mime || "video/mp4"} />
          </video>
        )}

        {mediaPreview.type === "audio" && (
          <div className="w-full max-w-xl bg-white rounded-2xl p-6 border">
            <p className="text-sm text-gray-600 mb-4">
              {lang === "EN" ? "Voice review" : "مراجعة صوتية"}
            </p>
            <audio controls autoPlay className="w-full">
              <source src={mediaPreview.url} type={mediaPreview.mime || "audio/ogg"} />
            </audio>
          </div>
        )}
      </div>
    </div>
  </div>
)}

{deleteRequestId !== null && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9998] p-4">
    <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-sm">
      <h2 className="text-lg font-bold text-red-600 mb-3">
        {TEXT.deleteRequestTitle}
      </h2>

      <p className="text-sm text-gray-600 mb-6">
        {TEXT.deleteRequestText}
      </p>

      <div className="flex justify-end gap-3">
        <button
          disabled={deletingRequest}
          className="px-4 py-2 bg-gray-200 rounded-xl text-sm font-medium hover:bg-gray-300 transition disabled:opacity-60"
          onClick={() => setDeleteRequestId(null)}
        >
          {TEXT.cancel}
        </button>

        <button
          disabled={deletingRequest}
          className="px-4 py-2 bg-red-600 text-white rounded-xl text-sm font-semibold hover:bg-red-700 transition disabled:opacity-60"
          onClick={confirmDeleteRequest}
        >
          {deletingRequest
            ? lang === "EN"
              ? "Deleting..."
              : "جاري الحذف..."
            : TEXT.confirmDelete}
        </button>
      </div>
    </div>
  </div>
)}

{toast && (
  <div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">
    <div
      className={`px-5 py-3 rounded-xl shadow-lg flex items-center gap-3 text-white ${
        toast.type === "success" ? "bg-green-600" : "bg-red-600"
      }`}
    >
      <span className="text-lg">
        {toast.type === "success" ? "✅" : "⚠️"}
      </span>
      <span className="text-sm font-medium">{toast.message}</span>
    </div>
  </div>
)}
        </main>
      </div>
    </div>
  );
}

export default AdminReviews;
